/* Momuna · Organizador de baúl plegable (01-11-2026). Lógica de la landing (secciones mm-org-*). JS nativo, sin librerías.
   Convive con momuna-ficha.js (hero, packs, barra, hoja de compra) sin tocarlo: se comunica por sus eventos
   ('momuna:pack', 'shopify:cart:lines-update') y por sus controles ([data-pack-radio], [data-hoja-abrir], [data-compra]).
   - Progreso de scroll --mm-p para las escenas (caos-ómetro, pliegue 3D, cotas); CSS lo anima donde hay animation-timeline.
   - Antes/después arrastrable, anatomía con globos, usos con puntos, videos a pedido, contador de precios, confeti + vibración,
     ?pack=2, eventos personalizados livianos (mm-org:*) y profundidad de scroll 50/75/100. Respeta prefers-reduced-motion. */
(function () {
  'use strict';
  var W = window, D = document;
  if (W.__mmOrg) return; W.__mmOrg = true;
  var reducido = W.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var nativoScroll = !!(W.CSS && CSS.supports && CSS.supports('animation-timeline: view()'));

  function publicar(nombre, datos) {
    datos = datos || {};
    try { W.dispatchEvent(new CustomEvent('mm-org:' + nombre, { detail: datos })); } catch (e) {}
    try { if (W.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('mm_org_' + nombre, datos); } catch (e) {}
  }
  function plata(c) { c = Math.round(c); var p = Math.floor(c / 100); return '$' + String(p).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function vibrar(ms) { if (navigator.vibrate) { try { navigator.vibrate(ms); } catch (e) {} } }

  /* ---- puente con la ficha ---- */
  var ficha = D.querySelector('[data-mm-ficha]');
  var packs = [];
  try { packs = JSON.parse(ficha.querySelector('[data-mm-packs]').textContent); } catch (e) {}
  var porId = {}; packs.forEach(function (p) { porId[p.id] = p; });
  var baseU = packs.reduce(function (m, p) { return Math.max(m, p.precio / p.n); }, 0);
  function packActual() {
    var r = ficha && ficha.querySelector('[data-pack-radio]:checked');
    return (r && porId[r.value]) || packs[0] || null;
  }
  function elegirPack(id, origen) {
    var r = ficha && ficha.querySelector('[data-pack-radio][value="' + id + '"]');
    if (!r || r.disabled) return false;
    if (!r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
    publicar('pack', { variante: +id, pack: porId[id] ? porId[id].n : null, origen: origen || 'landing' });
    return true;
  }
  /* Horizon en escritorio scrollea dentro de .page-wrapper (html/body con overflow hidden); en celular, la ventana */
  var scroller = (function () { var n = D.querySelector('.mm-org'); while (n && n !== D.body) { var cs = getComputedStyle(n); if (/(auto|scroll)/.test(cs.overflowY) && n.scrollHeight > n.clientHeight) return n; n = n.parentNode; } return null; })();
  function alScroll(fn) { W.addEventListener('scroll', fn, { passive: true }); if (scroller) scroller.addEventListener('scroll', fn, { passive: true }); }
  function esCelular() { return W.innerWidth < 990; }
  /* CTA de las secciones: en celular abre la hoja de compra de la ficha (sin scrollear); en escritorio sube al bloque de compra */
  function irAComprar(origen) {
    var abrir = D.querySelector('[data-hoja-abrir]'), compra = D.querySelector('[data-compra]');
    publicar('cta', { origen: origen });
    if (esCelular() && abrir) { abrir.click(); return; }
    if (compra) {
      (compra.querySelector('[data-packs]') || compra).scrollIntoView({ behavior: reducido ? 'auto' : 'smooth', block: 'start' });
      var pri = D.querySelector('[data-boton-principal]');
      if (pri) { pri.classList.remove('mm-org-pulso'); void pri.offsetWidth; pri.classList.add('mm-org-pulso'); }
    }
  }
  D.querySelectorAll('[data-org-cta]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); irAComprar(b.getAttribute('data-org-cta') || 'cta'); });
  });

  /* ---- contador de precios: los números "cuentan" al cambiar de pack ---- */
  function contar(el, desde, hasta) {
    if (reducido || desde === hasta) { el.textContent = plata(hasta); return; }
    var t0 = performance.now(), dur = 520;
    (function paso(t) {
      var k = clamp((t - t0) / dur, 0, 1), e = 1 - Math.pow(1 - k, 3);
      el.textContent = plata(desde + (hasta - desde) * e);
      if (k < 1) requestAnimationFrame(paso);
    })(t0);
  }
  var ultimo = packActual() ? packActual().precio : 0;
  function pintarPrecios(p) {
    if (!p) return;
    D.querySelectorAll('[data-org-total]').forEach(function (el) { contar(el, ultimo, p.precio); });
    D.querySelectorAll('[data-org-pack-nombre]').forEach(function (el) { el.textContent = p.titulo; });
    D.querySelectorAll('[data-org-pack-card]').forEach(function (c) { c.setAttribute('aria-checked', c.getAttribute('data-org-pack-card') === String(p.id) ? 'true' : 'false'); });
    /* el total grande de la ficha también cuenta (termina en el mismo valor que ya puso momuna-ficha.js) */
    if (ficha) ficha.querySelectorAll('.mm-f__precio [data-total]').forEach(function (el) { contar(el, ultimo, p.precio); });
    ultimo = p.precio;
  }
  W.addEventListener('momuna:pack', function (e) { var p = porId[e.detail && e.detail.variante]; if (p) pintarPrecios(p); });
  D.querySelectorAll('[data-org-pack-card]').forEach(function (c) {
    c.addEventListener('click', function () {
      var id = c.getAttribute('data-org-pack-card');
      if (elegirPack(id, 'oferta')) { c.classList.remove('mm-org__tick'); void c.offsetWidth; c.classList.add('mm-org__tick'); }
    });
    c.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); c.click(); } });
  });
  /* ?pack=2 preselecciona el pack de 2 (busca el número del pack en el selector de la ficha) */
  try {
    var qp = new URLSearchParams(location.search).get('pack');
    if (qp && ficha) {
      var objetivo = packs.filter(function (p) { return String(p.n) === String(qp); })[0];
      if (objetivo) elegirPack(objetivo.id, 'url');
    }
  } catch (e) {}
  if (packActual()) { var pa = packActual(); D.querySelectorAll('[data-org-pack-card]').forEach(function (c) { c.setAttribute('aria-checked', c.getAttribute('data-org-pack-card') === String(pa.id) ? 'true' : 'false'); }); }

  /* ---- confeti (una sola vez) + vibración al agregar a la bolsa ---- */
  var confetiHecho = false;
  function confeti() {
    if (confetiHecho || reducido) return; confetiHecho = true;
    var c = D.createElement('canvas'); c.className = 'mm-org-confeti'; c.width = W.innerWidth; c.height = W.innerHeight; D.body.appendChild(c);
    var ctx = c.getContext('2d'), cols = ['#FF6B57', '#FFE8A3', '#DDD7F6', '#CDE5F4', '#CCD8C3'], ps = [];
    for (var i = 0; i < 70; i++) ps.push({ x: c.width / 2 + (Math.random() - .5) * 120, y: c.height * .62, vx: (Math.random() - .5) * 14, vy: -(6 + Math.random() * 11), r: 4 + Math.random() * 5, a: Math.random() * 6.28, va: (Math.random() - .5) * .3, col: cols[i % cols.length] });
    var t0 = performance.now();
    (function paso(t) {
      var k = (t - t0) / 1100; ctx.clearRect(0, 0, c.width, c.height);
      ps.forEach(function (p) { p.x += p.vx; p.y += p.vy; p.vy += .42; p.vx *= .985; p.a += p.va; ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.a); ctx.globalAlpha = clamp(1.3 - k, 0, 1); ctx.fillStyle = p.col; ctx.fillRect(-p.r / 2, -p.r / 2, p.r, p.r * .6); ctx.restore(); });
      if (k < 1.3) requestAnimationFrame(paso); else c.remove();
    })(t0);
  }
  D.addEventListener('shopify:cart:lines-update', function () { confeti(); vibrar(18); publicar('agregado', { pack: packActual() ? packActual().n : null }); });
  W.addEventListener('momuna:compra', function () { vibrar(14); });

  /* ---- progreso de scroll (--mm-p) para las escenas; CSS lo hace solo donde hay animation-timeline ---- */
  var escenas = Array.prototype.slice.call(D.querySelectorAll('[data-org-scroll]'));
  var caos = D.querySelector('[data-org-caos]');
  function progreso(el) {
    var r = el.getBoundingClientRect(), vh = W.innerHeight || 1;
    /* 0 cuando el elemento asoma un 25 % por abajo; 1 cuando su centro pasó el 30 % superior */
    var ini = vh * .75, fin = vh * .3 - r.height / 2;
    return clamp((ini - r.top) / (ini - fin), 0, 1);
  }
  function pintarCaos(p) {
    if (!caos) return;
    var n = caos.querySelector('[data-org-caos-num]'), cara = caos.querySelector('[data-org-cara]'), txt = caos.querySelector('[data-org-caos-txt]');
    var orden = Math.round(p * 100);
    if (n) n.textContent = orden + '%';
    if (cara) cara.classList.toggle('is-feliz', p > .5);
    if (txt) txt.textContent = p < .25 ? txt.getAttribute('data-t0') : p < .55 ? txt.getAttribute('data-t1') : p < .85 ? txt.getAttribute('data-t2') : txt.getAttribute('data-t3');
  }
  var pendiente = false;
  function tick() {
    pendiente = false;
    escenas.forEach(function (el) {
      var p = reducido ? 1 : progreso(el);
      if (!nativoScroll || reducido) el.style.setProperty('--mm-p', p.toFixed(3));
      if (el.hasAttribute('data-org-caos')) pintarCaos(p);
    });
  }
  function pedir() { if (!pendiente) { pendiente = true; requestAnimationFrame(tick); } }
  if (escenas.length) { alScroll(pedir); W.addEventListener('resize', pedir); pedir(); }

  /* ---- aparición: respaldo con IntersectionObserver donde no hay view timeline ---- */
  if (!nativoScroll && 'IntersectionObserver' in W) {
    var ioRev = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visto'); ioRev.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    D.querySelectorAll('.mm-org__rev').forEach(function (el) { ioRev.observe(el); });
  } else if (!nativoScroll) { D.querySelectorAll('.mm-org__rev').forEach(function (el) { el.classList.add('is-visto'); }); }

  /* ---- antes / después ---- */
  D.querySelectorAll('[data-org-ad]').forEach(function (ad) {
    var mango = ad.querySelector('.mm-org__ad-mango'), x = 50, usado = false, arrastrando = false;
    function poner(v, anunciar) {
      x = clamp(v, 2, 98); ad.style.setProperty('--x', x.toFixed(1));
      mango.setAttribute('aria-valuenow', Math.round(x));
      if (anunciar && !usado) { usado = true; ad.classList.add('is-usado'); publicar('antes_despues', { origen: anunciar }); }
    }
    function desdeEvento(e) { var r = ad.getBoundingClientRect(); return (e.clientX - r.left) / r.width * 100; }
    ad.addEventListener('pointerdown', function (e) { arrastrando = true; ad.setPointerCapture && ad.setPointerCapture(e.pointerId); poner(desdeEvento(e), 'arrastre'); e.preventDefault(); });
    ad.addEventListener('pointermove', function (e) { if (arrastrando) poner(desdeEvento(e)); });
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (n) { ad.addEventListener(n, function () { arrastrando = false; }); });
    mango.addEventListener('keydown', function (e) {
      var paso = e.shiftKey ? 10 : 4;
      if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') { poner(x - paso, 'teclado'); e.preventDefault(); }
      if (e.key === 'ArrowRight' || e.key === 'ArrowUp') { poner(x + paso, 'teclado'); e.preventDefault(); }
      if (e.key === 'Home') { poner(2, 'teclado'); e.preventDefault(); } if (e.key === 'End') { poner(98, 'teclado'); e.preventDefault(); }
    });
    /* sugerencia inicial: la línea va y viene una vez cuando aparece en pantalla */
    if (!reducido && 'IntersectionObserver' in W) {
      var io = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting || usado) return; io.disconnect();
        ad.classList.add('is-sugiere'); var t0 = performance.now();
        (function paso(t) {
          if (usado) return; var k = clamp((t - t0) / 1800, 0, 1);
          poner(50 - Math.sin(k * Math.PI * 2) * 14 * Math.sin(k * Math.PI));
          if (k < 1) requestAnimationFrame(paso); else ad.classList.remove('is-sugiere');
        })(t0);
      }, { threshold: .6 });
      io.observe(ad);
    }
    poner(50);
  });

  /* ---- anatomía: puntos con globo ---- */
  D.querySelectorAll('[data-org-anat]').forEach(function (anat) {
    var puntos = Array.prototype.slice.call(anat.querySelectorAll('[data-org-punto]'));
    var chips = Array.prototype.slice.call(anat.parentNode.querySelectorAll('[data-org-chip]'));
    function cerrar() {
      puntos.forEach(function (p) { p.setAttribute('aria-expanded', 'false'); });
      chips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
      anat.querySelectorAll('.mm-org__globo').forEach(function (g) { g.classList.remove('is-on'); });
    }
    function abrir(k, origen) {
      var ya = anat.querySelector('[data-org-punto="' + k + '"][aria-expanded="true"]');
      cerrar(); if (ya) return;
      var p = anat.querySelector('[data-org-punto="' + k + '"]'), g = anat.querySelector('[data-org-globo="' + k + '"]');
      if (!p || !g) return;
      p.setAttribute('aria-expanded', 'true');
      chips.forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-org-chip') === k ? 'true' : 'false'); });
      var x = parseFloat(p.style.getPropertyValue('--x')), y = parseFloat(p.style.getPropertyValue('--y'));
      g.classList.toggle('is-izq', x < 30); g.classList.toggle('is-der', x > 70); g.classList.toggle('is-arriba', y > 62);
      g.classList.add('is-on');
      publicar('anatomia', { parte: k, origen: origen });
    }
    puntos.forEach(function (p) { p.addEventListener('click', function (e) { e.stopPropagation(); abrir(p.getAttribute('data-org-punto'), 'punto'); }); });
    chips.forEach(function (c) { c.addEventListener('click', function (e) { e.stopPropagation(); abrir(c.getAttribute('data-org-chip'), 'chip'); }); });
    D.addEventListener('click', function (e) { if (!anat.contains(e.target)) cerrar(); });
    D.addEventListener('keydown', function (e) { if (e.key === 'Escape') cerrar(); });
  });

  /* ---- carruseles con puntos (usos, videos) ---- */
  D.querySelectorAll('[data-org-pista]').forEach(function (pista) {
    var puntos = pista.parentNode.querySelectorAll('[data-org-puntos] i'); if (!puntos.length) return;
    var items = pista.children, t;
    pista.addEventListener('scroll', function () {
      clearTimeout(t); t = setTimeout(function () {
        var c = pista.scrollLeft + pista.clientWidth / 2, idx = 0;
        for (var i = 0; i < items.length; i++) { if (items[i].offsetLeft <= c) idx = i; }
        puntos.forEach(function (p, i) { p.classList.toggle('is-on', i === idx); });
      }, 60);
    }, { passive: true });
  });

  /* ---- videos: se cargan solo al tocar; uno a la vez; se pausan al salir de pantalla ---- */
  var vids = Array.prototype.slice.call(D.querySelectorAll('[data-org-vid]'));
  function pararTodos(menos) { vids.forEach(function (v) { if (v !== menos) { var el = v.querySelector('video'); if (el) { el.pause(); } v.classList.remove('is-play'); } }); }
  vids.forEach(function (v) {
    var play = v.querySelector('[data-org-play]'), parar = v.querySelector('[data-org-parar]');
    play.addEventListener('click', function () {
      pararTodos(v);
      var el = v.querySelector('video');
      if (!el) { el = D.createElement('video'); el.setAttribute('playsinline', ''); el.preload = 'auto'; el.loop = true; el.src = v.getAttribute('data-org-vid'); el.poster = v.querySelector('img') ? v.querySelector('img').currentSrc : ''; v.insertBefore(el, play); }
      v.classList.add('is-play'); el.muted = false;
      var pr = el.play(); if (pr && pr.catch) pr.catch(function () { el.muted = true; el.play().catch(function () {}); });
      publicar('video', { nombre: v.getAttribute('data-org-nombre') });
    });
    parar.addEventListener('click', function () { var el = v.querySelector('video'); if (el) el.pause(); v.classList.remove('is-play'); });
  });
  if (vids.length && 'IntersectionObserver' in W) {
    var ioV = new IntersectionObserver(function (es) { es.forEach(function (e) { if (!e.isIntersecting) { var el = e.target.querySelector('video'); if (el && !el.paused) { el.pause(); e.target.classList.remove('is-play'); } } }); }, { threshold: .2 });
    vids.forEach(function (v) { ioV.observe(v); });
  }

  /* ---- medidas: los números cuentan al verse ---- */
  var nums = D.querySelectorAll('[data-org-num]');
  if (nums.length && 'IntersectionObserver' in W) {
    var ioN = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return; ioN.unobserve(e.target);
        var el = e.target, fin = +el.getAttribute('data-org-num'), t0 = performance.now();
        if (reducido) { el.textContent = fin; return; }
        (function paso(t) { var k = clamp((t - t0) / 900, 0, 1), ea = 1 - Math.pow(1 - k, 3); el.textContent = Math.round(fin * ea); if (k < 1) requestAnimationFrame(paso); })(t0);
      });
    }, { threshold: .5 });
    nums.forEach(function (n) { ioN.observe(n); });
  }

  /* ---- View Transitions al elegir una miniatura de la galería (la ficha sigue manejando el estado con su scroll) ---- */
  var pistaG = ficha && ficha.querySelector('[data-pista]');
  if (pistaG && D.startViewTransition && !reducido) {
    pistaG.style.viewTransitionName = 'mm-org-galeria';
    ficha.querySelectorAll('[data-mini]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        var i = +b.getAttribute('data-mini'), slide = pistaG.children[i]; if (!slide) return;
        e.stopImmediatePropagation(); e.preventDefault();
        D.startViewTransition(function () { pistaG.scrollTo({ left: slide.offsetLeft, behavior: 'instant' }); });
      }, true);
    });
  }

  /* ---- profundidad de scroll 50 / 75 / 100 ---- */
  var hitos = [50, 75, 100], vistos = {};
  function medir() {
    var h = scroller ? scroller.scrollHeight - scroller.clientHeight : D.documentElement.scrollHeight - W.innerHeight; if (h <= 0) return;
    var p = ((scroller ? scroller.scrollTop : W.scrollY) / h) * 100;
    hitos.forEach(function (m) { if (!vistos[m] && p >= m - .5) { vistos[m] = true; publicar('scroll', { profundidad: m }); } });
  }
  alScroll(function () { requestAnimationFrame(medir); });
})();
